import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpEvent,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'environments/environment';

export interface UploadImagesOptions {
  withProgress?: boolean;
}

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private baseUrl = environment.apiUrls.notificationsService;

  constructor(private http: HttpClient) {}

  private headers(): HttpHeaders {
    return new HttpHeaders({
      'message-id':
        (crypto as any)?.randomUUID?.() ?? Math.random().toString(36).slice(2),
      location: '192.168.1.100',
    });
  }

  markAsRead(
    notificationId: string,
    userId: string
  ): Observable<any | HttpEvent<any>> {
    const url = `${this.baseUrl}/notifications/user/read-status`;

    return this.http.put(
      url,
      {
        notificationId,
        userId,
        isRead: true,
      },
      { headers: this.headers() }
    );
  }
}
